import { WizardNavigationService } from "@/shared/Wizard/services/WizardNavigationService";
import { WizardStepAvailabiltyModel } from "@/shared/Wizard/models/WizardStepAvailabilityModel";
import { WizardModel } from "@/shared/Wizard/models/WizardModel";
import { WizardStepStatusType } from "@/shared/Wizard/models/WizardStep";
import { ExecutionStatusType } from "@/shared/Executions/models/ExecutionStatusType";
import { AdvancedAnalysisWizardSharedModel } from "../models/AdvancedAnaylsisWizardSharedModel";
import { AdvancedAnalysisWizardStep } from "../models/AdvancedAnalysisWizardStep";
import { AdvancedAnalysisWizardStepType } from "../models/AdvancedAnyalsisWizardStepType";
import AdvancedAnalysisStepUnavailable from "../AdvancedAnalysis/components/AdvancedAnalysisStepUnavailable.vue";


export class AdvancedAnalysisWizardNavigationService extends WizardNavigationService<AdvancedAnalysisWizardSharedModel, AdvancedAnalysisWizardStep, AdvancedAnalysisWizardStepType> {

    static readonly injectableKey = 'AdvancedAnalysisWizardNavigationService';

    get injectableKey() {
        return (this.constructor as typeof AdvancedAnalysisWizardNavigationService).injectableKey;
    }

    private _stepOrder = Object.values(AdvancedAnalysisWizardStepType) as (string | number)[];

    public getIsStepAvailable(stepType: AdvancedAnalysisWizardStepType,
        sharedModel: AdvancedAnalysisWizardSharedModel): WizardStepAvailabiltyModel {

        const model = new WizardStepAvailabiltyModel(false, undefined, stepType !== AdvancedAnalysisWizardStepType.InputData);

        const hasSelectedInput = sharedModel?.inputFile != null;
        //@ts-ignore
        const hasCompletedAdvancedAnalysisExecution = sharedModel?.advancedAnalysisExecution?.id != null && sharedModel?.advancedAnalysisExecution?.status === ExecutionStatusType.Succeeded;


        switch (stepType) {
            case AdvancedAnalysisWizardStepType.InputData:
                model.isAvailable = true;
                break;
            case AdvancedAnalysisWizardStepType.AdvancedAnalysisConfig:
                model.unavailableComponent = AdvancedAnalysisStepUnavailable;
                if (hasSelectedInput) {
                    model.isAvailable = true;
                }
                break;
        }


        return model;

    }

    public getPreviousWizardStep(
        activeStep: AdvancedAnalysisWizardStep,
        steps: AdvancedAnalysisWizardStep[]): AdvancedAnalysisWizardStep | undefined {

        if (activeStep == null || !steps?.length) return;

        const currentType = activeStep.type as string;
        if (!currentType) return undefined;

        const idx = this._stepOrder.indexOf(currentType);
        if (idx <= 0) return undefined;

        const prevType = this._stepOrder[idx - 1];
        return steps.find((s) => s.type === prevType);

    }

    public getNextWizardStep(
        activeStep: AdvancedAnalysisWizardStep,
        steps: AdvancedAnalysisWizardStep[]): AdvancedAnalysisWizardStep | undefined {

        if (activeStep == null || !steps?.length) return;

        const currentType = activeStep?.type
        if (!currentType) return undefined

        const idx = this._stepOrder.indexOf(currentType)
        if (idx < 0 || idx >= this._stepOrder.length - 1) return undefined

        const nextType = this._stepOrder[idx + 1]
        return steps?.find((s) => s.type === nextType)

    }

    public setActiveWizardStep(step: AdvancedAnalysisWizardStep, wizardModel: WizardModel<AdvancedAnalysisWizardStep, AdvancedAnalysisWizardSharedModel>): void {

        if (wizardModel == null) throw Error("wizardModel is required");
        if (step != null) {
            wizardModel.activeStep = step;
        }

    }

    public setActiveWizardStepByType(stepType: AdvancedAnalysisWizardStepType, wizardModel: WizardModel<AdvancedAnalysisWizardStep, AdvancedAnalysisWizardSharedModel>): void {

        if (stepType == null) throw Error("stepType is required");
        if (wizardModel == null) throw Error("wizardModel is required");

        const step = wizardModel.steps?.find((s) => s.type === stepType)
        if (step != null) wizardModel.activeStep = step;

    }

    public trySetWizardActiveStepStatus(wizardModel: WizardModel<AdvancedAnalysisWizardStep, AdvancedAnalysisWizardSharedModel>, statusType: WizardStepStatusType, message?: string): void {

        if (wizardModel == null) throw Error("wizardModel is required");
        if (statusType == null) throw Error("statusType is required");
        const activeStep = wizardModel.activeStep;
        if (activeStep) {
            activeStep.statusType = statusType;
            activeStep.statusMessage = message;
        }

    }
}